import * as React from "react";
const IconUploadDocs = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3_91997)">
      <path
        d="M7.98645 6.49243H17.7365C19.8431 6.49243 20.8965 6.49243 21.6532 6.99802C21.9807 7.2169 22.262 7.49815 22.4809 7.82572C22.9443 8.51937 22.9829 9.25224 22.9862 10.9924M12.9865 6.49243L12.353 5.22556C11.8282 4.17601 11.3487 3.11955 10.1857 2.68344C9.67635 2.49243 9.09447 2.49243 7.93072 2.49243C6.11425 2.49243 5.20601 2.49243 4.52451 2.87275C4.03872 3.14385 3.63787 3.5447 3.36677 4.03049C2.98645 4.71199 2.98645 5.62023 2.98645 7.4367V10.4924C2.98645 15.2065 2.98645 17.5635 4.45092 19.028C5.80795 20.385 7.93138 20.4846 11.9865 20.4919H13.9865"
        stroke={props.color || "#1C1C2C"}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M19.4864 13.4924L19.4865 21.4924M19.4864 13.4924C18.7862 13.4924 17.478 15.4867 16.9865 15.9924M19.4864 13.4924C20.1867 13.4924 21.4949 15.4867 21.9865 15.9924"
        stroke={props.color || "#1C1C2C"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_91997">
        <rect width={24} height={24} fill="white" transform="translate(0.98645 -0.00756836)" />
      </clipPath>
    </defs>
  </svg>
);
export default IconUploadDocs;
